@if(mode==="edit"){
@if(source !== 'enrollment'){
<div class="ppl-mt8">
  @for(header of extractValues('header'); track $index){
  <h2 tabindex="-1" pplAutoFocusHeader>{{header}}</h2>
  }
  @for(text of extractValues('text'); track $index){
  <p class="ppl-description">{{text}}</p>
  }
</div>
}
<div [ngClass]="{'ppl-mt24': source !== 'enrollment'}">
  <nz-card nz-col [nzSpan]="source !== 'enrollment' ? 20 : 24" class="ppl-p24 ppl-step-main" [nzBordered]="false">
    <form nz-form [formGroup]="preferncesForm" class="ppl-p0">
      @if(isAttrAvailable('contactType')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="contactType"
          class="ppl-form-label">{{getAttributes('contactType').label}}
          @if(getAttributes('contactType').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <nz-radio-group [ngClass]="{'error': validationErrors['contactType'] }" nz-tooltip
            nzTooltipTitle="{{getAttributes('contactType').tooltip}}" nzTooltipPlacement="topRight"
            formControlName="contactType" id="contactType" class="ppl-radio-group"
            [attr.aria-invalid]="validationErrors['contactType'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['contactType'] ? 'contactType-error' : null">
            @for(opt of contactType; track $index){
            <label nz-radio-button [nzValue]="opt.lkpValueCode">{{opt.lkpValueName}}</label>
            }
          </nz-radio-group>
          @if (validationErrors['contactType']) {
          <span class="pl-1 error-message" id="contactType-error"
            role="alert">{{validationErrors['contactType']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(preferncesForm.get('contactType')?.value === 'OTH'){
      @if(isAttrAvailable('contactFirstName')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="contactFirstName" class="ppl-form-label"></nz-form-label>
        <nz-form-control class="ppl-form-control">
          <input nz-tooltip nzTooltipTitle="{{getAttributes('contactFirstName').tooltip}}" nzTooltipPlacement="topRight"
            nz-input formControlName="contactFirstName" id="contactFirstName"
            [ngClass]="{'error': validationErrors['contactFirstName'] }"
            placeholder="{{getAttributes('contactFirstName').placeholder}}"
            [attr.aria-invalid]="validationErrors['contactFirstName'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['contactFirstName'] ? 'contactFirstName-error' : null" />
          @if (validationErrors['contactFirstName']) {
          <span class="pl-1 error-message" id="contactFirstName-error"
            role="alert">{{validationErrors['contactFirstName']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('contactLastName')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="contactLastName" class="ppl-form-label"></nz-form-label>
        <nz-form-control class="ppl-form-control">
          <input nz-tooltip nzTooltipTitle="{{getAttributes('contactLastName').tooltip}}" nzTooltipPlacement="topRight"
            nz-input formControlName="contactLastName" id="contactLastName"
            [ngClass]="{'error': validationErrors['contactLastName'] }"
            placeholder="{{getAttributes('contactLastName').placeholder}}"
            [attr.aria-invalid]="validationErrors['contactLastName'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['contactLastName'] ? 'contactLastName-error' : null" />
          @if (validationErrors['contactLastName']) {
          <span class="pl-1 error-message" id="contactLastName-error"
            role="alert">{{validationErrors['contactLastName']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('contactEmail')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="contactEmail" class="ppl-form-label"></nz-form-label>
        <nz-form-control class="ppl-form-control">
          <input nz-tooltip nzTooltipTitle="{{getAttributes('contactEmail').tooltip}}" nzTooltipPlacement="topRight"
            nz-input formControlName="contactEmail" id="contactEmail"
            [ngClass]="{'error': validationErrors['contactEmail'] }"
            placeholder="{{getAttributes('contactEmail').placeholder}}"
            [attr.aria-invalid]="validationErrors['contactEmail'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['contactEmail'] ? 'contactEmail-error' : null" />
          @if (validationErrors['contactEmail']) {
          <span class="pl-1 error-message" id="contactEmail-error"
            role="alert">{{validationErrors['contactEmail']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('contactPhone')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="contactPhone" class="ppl-form-label"></nz-form-label>
        <nz-form-control class="ppl-form-control">
          <input nz-tooltip nzTooltipTitle="{{getAttributes('contactPhone').tooltip}}" nzTooltipPlacement="topRight"
            nz-input formControlName="contactPhone" id="contactPhone"
            [ngClass]="{'error': validationErrors['contactPhone'] }"
            placeholder="{{getAttributes('contactPhone').placeholder}}"
            [attr.aria-invalid]="validationErrors['contactPhone'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['contactPhone'] ? 'contactPhone-error' : null" />
          @if (validationErrors['contactPhone']) {
          <span class="pl-1 error-message" id="contactPhone-error"
            role="alert">{{validationErrors['contactPhone']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }

      }
      @if(isAttrAvailable('spokenLanguages')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="spokenLanguages"
          class="ppl-form-label">{{getAttributes('spokenLanguages').label}}
          @if(getAttributes('spokenLanguages').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip
          nzTooltipTitle="{{getAttributes('spokenLanguages').tooltip}}" nzTooltipPlacement="topRight">
          <div [ngClass]="{'error': validationErrors['spokenLanguages'] }">
            <ppl-multiselect formControlName="spokenLanguages" id="spokenLanguages" [options]="languages"
              [showClear]="true" placeholder="{{getAttributes('spokenLanguages').label}}" [optionLabel]="'lkpValueName'"
              [optionValue]="'lkpValueCode'"
              [attr.aria-invalid]="validationErrors['spokenLanguages'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['spokenLanguages'] ? 'spokenLanguages-error' : null">
            </ppl-multiselect>
          </div>
          @if (validationErrors['spokenLanguages']) {
          <span class="pl-1 error-message" id="spokenLanguages-error"
            role="alert">{{validationErrors['spokenLanguages']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('primaryLanguage')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="primaryLanguage"
          class="ppl-form-label">{{getAttributes('primaryLanguage').label}}
          @if(getAttributes('primaryLanguage').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip
          nzTooltipTitle="{{getAttributes('primaryLanguage').tooltip}}" nzTooltipPlacement="topRight">
          <div [ngClass]="{ 'error': validationErrors['primaryLanguage'] }">
            <ppl-dropdown-select formControlName="primaryLanguage" id="primaryLanguage" class="ppl-select"
              [options]="languages" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
              [placeholder]="getAttributes('primaryLanguage')?.label" aria-required="true"
              aria-describedby="primaryLanguageError" [attr.aria-label]="getAttributes('primaryLanguage')?.label"
              [attr.aria-invalid]="validationErrors['primaryLanguage'] ? 'true' : 'false'">
            </ppl-dropdown-select>

            @if (validationErrors['primaryLanguage']) {
            <span id="primaryLanguageError" class="pl-1 error-message" role="alert">
              {{ validationErrors['primaryLanguage'] }}
            </span>
            }
          </div>

        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('formLanguage')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="formLanguage"
          class="ppl-form-label">{{getAttributes('formLanguage').label}}
          @if(getAttributes('formLanguage').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('formLanguage').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{ 'error': validationErrors['formLanguage'] }">
            <ppl-dropdown-select formControlName="formLanguage" id="formLanguage" [options]="formLanguages"
              [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
              [placeholder]="getAttributes('formLanguage')?.label" aria-required="true"
              aria-describedby="formLanguageError" [attr.aria-label]="getAttributes('formLanguage')?.label"
              [attr.aria-invalid]="validationErrors['formLanguage'] ? 'true' : 'false'">
            </ppl-dropdown-select>
          </div>

          @if (validationErrors['formLanguage']) {
          <span id="formLanguageError" class="pl-1 error-message" role="alert">
            {{validationErrors['formLanguage']}}
          </span>
          }

        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('emergencyContact')){
      <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="birthPlace" id="emergencyContact-label"
          class="ppl-form-label">{{getAttributes('emergencyContact').label}}
          @if(getAttributes('emergencyContact').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="" nzTooltipPlacement="topRight">
            <input nz-input formControlName="emergencyContactFirstName" id="emergencyContactFirstName"
              placeholder="First Name" aria-labelledby="emergencyContact-label" aria-autocomplete="none"
              maxlength="20" />
          </div>
        </nz-form-control>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="" nzTooltipPlacement="topRight">
            <input nz-input formControlName="emergencyContactLastName" aria-labelledby="emergencyContact-label"
              aria-autocomplete="none" id="emergencyContactLastName" placeholder="Last Name" maxlength="20" />
          </div>
        </nz-form-control>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="" nzTooltipPlacement="topRight">
            <input nz-input formControlName="emergencyContactPhone" aria-labelledby="emergencyContact-label"
              id="emergencyContactPhone" placeholder="Number" aria-autocomplete="none" />
          </div>
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('registerPref')){
      <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="registerPref"
          class="ppl-form-label" id="register-pref-label">{{getAttributes('registerPref').label}}
          @if(getAttributes('registerPref').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('registerPref').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{ 'error': validationErrors['registerPref'] }">
            <ppl-dropdown-select formControlName="registerPref" id="registerPref" class="ppl-select"
              [options]="participantRegisterMode" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
              [placeholder]="'Select Preference'" aria-required="true"
              [ariaLabelledBy]="'register-pref-label'"
              [attr.aria-label]="getAttributes('registerPref')?.label"
              [attr.aria-invalid]="validationErrors['registerPref'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['registerPref'] ? 'registerPrefError' : null">
            </ppl-dropdown-select>
          </div>
          @if (validationErrors['registerPref']) {
          <span id="registerPrefError" class="pl-1 error-message" role="alert">
            {{ validationErrors['registerPref'] }}
          </span>
          }

        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('daysToContact')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="daysToContact" class="ppl-form-label" id="daysToContact-label"
          [attr.aria-label]="getDaysToContactAriaLabel()">
          {{ getAttributes('daysToContact').label }}
          @if(getAttributes('daysToContact').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('daysToContact').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [formGroup]="preferncesForm">
            <div formArrayName="daysToContact" role="group" [attr.aria-labelledby]="'daysToContact-label'"
              [attr.aria-describedby]="getAttributes('daysToContact').tooltip ? 'daysToContact-tooltip' : null">
              <ng-container>
                @for(day of daysOfWeek; track $index){
                <label nz-checkbox [formControlName]="$index" [attr.aria-label]="shortToFullDayMap[day]">
                  {{ day }}
                </label>
                }
              </ng-container>
            </div>
          </div>
          @if (validationErrors['daysToContact']) {
          <span class="pl-1 error-message" id="daysToContact-error">{{validationErrors['daysToContact']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="ppl-form-item">
        <div nz-col [nzSm]="8" [nzXs]="24" class="ppl-form-label"></div>
        <div class="time-picker-new" [ngClass]="{'error': validationErrors['dob'] }">
          <ppl-timepicker class="p-calendar-time" formControlName="startContactTime" id="startContactTime"
            [placeholder]="getAttributes('startContactTime').placeholder"
            [ariaLabel]="'Best time to contact start time'"></ppl-timepicker>
            <ppl-timepicker formControlName="endContactTime" id="endContactTime"
            [placeholder]="getAttributes('endContactTime').placeholder"
            [ariaLabel]="'Best time to contact end time'"></ppl-timepicker>
        </div>

      </nz-form-item>
      }
      @if(isAttrAvailable('otherDetails')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="otherDetails"
          class="ppl-form-label">{{getAttributes('otherDetails').label}}
          @if(getAttributes('otherDetails').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('otherDetails').tooltip}}"
          nzTooltipPlacement="topRight">
          <textarea rows="4" nz-input formControlName="otherDetails" id="otherDetails"
            [ngClass]="{'error': validationErrors['otherDetails'] }"
            placeholder="{{getAttributes('otherDetails').placeholder}}"
            [attr.aria-invalid]="validationErrors['otherDetails'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['otherDetails'] ? 'otherDetails-error' : null"></textarea>
          @if (validationErrors['otherDetails']) {
          <span class="pl-1 error-message" id="otherDetails-error"
            role="alert">{{validationErrors['otherDetails']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('specialAccomdation')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="specialAccomdation"
          class="ppl-form-label">{{getAttributes('specialAccomdation').label}}
          @if(getAttributes('specialAccomdation').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip
          nzTooltipTitle="{{getAttributes('specialAccomdation').tooltip}}" nzTooltipPlacement="topRight">
          <div [ngClass]="{ 'error': validationErrors['specialAccomdation'] }">
            <ppl-dropdown-select formControlName="specialAccomdation" id="specialAccomdation" [options]="accommodations"
              [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
              [placeholder]="getAttributes('specialAccomdation')?.label" [disabled]="formReadonly" aria-required="true"
              aria-describedby="specialAccomdationError" [attr.aria-label]="getAttributes('specialAccomdation')?.label"
              [attr.aria-invalid]="validationErrors['specialAccomdation'] ? 'true' : 'false'">
            </ppl-dropdown-select>

            @if (validationErrors['specialAccomdation']) {
            <span id="specialAccomdationError" class="pl-1 error-message" role="alert">
              {{ validationErrors['specialAccomdation'] }}
            </span>
            }
          </div>
        </nz-form-control>
      </nz-form-item>
      }
      @if(preferncesForm.get('specialAccomdation')?.value === 'OTH'){
      @if(isAttrAvailable('specialAccomdationOther')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" zFor="specialAccomdationOther" class="ppl-form-label"></nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip
          nzTooltipTitle="{{getAttributes('specialAccomdationOther').tooltip}}" nzTooltipPlacement="topRight">
          <textarea [ngClass]="{'error': validationErrors['specialAccomdationOther'] }" nz-tooltip rows="4" nz-input
            formControlName="specialAccomdationOther" id="specialAccomdationOther"
            placeholder="{{getAttributes('specialAccomdationOther').placeholder}}"
            [attr.aria-invalid]="validationErrors['specialAccomdationOther'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['specialAccomdationOther'] ? 'specialAccomdationOther-error' : null"></textarea>
          @if (validationErrors['specialAccomdationOther']) {
          <span class="pl-1 error-message" id="specialAccomdationOther-error"
            role="alert">{{validationErrors['specialAccomdationOther']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      }
      @if(isAttrAvailable('nonProfitStatus')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="9" [nzXs]="24" nzFor="nonProfitStatus"
          class="ppl-form-label">{{getAttributes('nonProfitStatus').label}}
          @if(getAttributes('nonProfitStatus').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
      </nz-form-item>
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="taxExempt"
          class="ppl-form-label">{{getAttributes('taxExempt').label}}
          @if(getAttributes('taxExempt').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div [ngClass]="{ 'error': validationErrors['taxExempt'] }">
            <ppl-dropdown-select formControlName="taxExempt" id="taxExempt" class="ppl-select"
              [options]="taxExemptOptions" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
              [placeholder]="getAttributes('taxExempt')?.placeholder" aria-required="true"
              aria-describedby="taxExemptError" aria-label="Select Tax Exempt"
              [attr.aria-invalid]="validationErrors['taxExempt'] ? 'true' : 'false'"
              style="width: 100%; margin-bottom: 16px;">
            </ppl-dropdown-select>

            @if (validationErrors['taxExempt']) {
            <span id="taxExemptError" class="pl-1 error-message" role="alert">
              {{ validationErrors['taxExempt'] }}
            </span>
            }
          </div>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="nprftDocumentationReceived"
          class="ppl-form-label">{{getAttributes('nprftDocumentationReceived').label}}
          @if(getAttributes('nprftDocumentationReceived').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div [ngClass]="{ 'error': validationErrors['nprftDocumentationReceived'] }">
            <ppl-dropdown-select formControlName="nprftDocumentationReceived" id="nprftDocumentationReceived"
              class="ppl-select" [options]="[
              { lkpValueCode: 'yes', lkpValueName: 'Yes' },
              { lkpValueCode: 'no', lkpValueName: 'No' }
            ]" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
              [placeholder]="getAttributes('nprftDocumentationReceived')?.placeholder" aria-required="true"
              aria-describedby="nprftDocumentationReceivedError" aria-label="Non-profit Documentation Received"
              [attr.aria-invalid]="validationErrors['nprftDocumentationReceived'] ? 'true' : 'false'"
              style="width: 100%; margin-bottom: 16px;">
            </ppl-dropdown-select>

            @if (validationErrors['nprftDocumentationReceived']) {
            <span id="nprftDocumentationReceivedError" class="pl-1 error-message" role="alert">
              {{ validationErrors['nprftDocumentationReceived'] }}
            </span>
            }
          </div>
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('availabilityDays')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="availabilityDays"
          class="ppl-form-label">{{getAttributes('availabilityDays').label}}
          @if(getAttributes('availabilityDays').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip
          nzTooltipTitle="{{getAttributes('availabilityDays').tooltip}}" nzTooltipPlacement="topRight">
          <div [formGroup]="preferncesForm">
            <div formArrayName="availabilityDays">
              <ng-container>
                @for(day of daysOfWeek; track $index){
                <label nz-checkbox [formControlName]="$index">
                  {{ day }}
                </label>
                }
              </ng-container>
            </div>
          </div>
          @if (validationErrors['availabilityDays']) {
          <span class="pl-1 error-message">{{validationErrors['availabilityDays']}}</span>
          }
        </nz-form-control>
      </nz-form-item>

      }
      @if(isAttrAvailable('availabilityTiming')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="availabilityTiming"
          class="ppl-form-label">{{getAttributes('availabilityTiming').label}}
          @if(getAttributes('availabilityTiming').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <div class="time-picker-new" [ngClass]="{'error': validationErrors['availabilityTiming'] }">
          <ppl-timepicker class="p-calendar-time" formControlName="availabilityTimingStart" id="availabilityTimingStart"
            [placeholder]="getAttributes('availabilityTiming').placeholder"></ppl-timepicker>
          <ppl-timepicker formControlName="availabilityTimingEnd" id="availabilityTimingEnd"
            [placeholder]="getAttributes('availabilityTiming').placeholder"
            [attr.aria-invalid]="validationErrors['availabilityTiming'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['availabilityTiming'] ? 'availabilityTiming-error' : null"></ppl-timepicker>
        </div>
        @if (validationErrors['availabilityTiming']) {
        <span class="pl-1 error-message" id="availabilityTiming-error"
          role="alert">{{validationErrors['availabilityTiming']}}</span>
        }
      </nz-form-item>
      }
      @if(isAttrAvailable('distanceWillingToTravel')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="distanceWillingToTravel"
          class="ppl-form-label">{{getAttributes('distanceWillingToTravel').label}}
          @if(getAttributes('distanceWillingToTravel').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('distanceWillingToTravel')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <input nz-input formControlName="distanceWillingToTravel" id="distanceWillingToTravel"
              placeholder="{{getAttributes('distanceWillingToTravel').placeholder}}"
              [ngClass]="{'error': validationErrors['distanceWillingToTravel'] }"
              [attr.aria-invalid]="validationErrors['distanceWillingToTravel'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['distanceWillingToTravel'] ? 'distanceWillingToTravel-error' : null" />
          </div>
          @if (validationErrors['distanceWillingToTravel']) {
          <span class="pl-1 error-message" id="distanceWillingToTravel-error"
            role="alert">{{validationErrors['distanceWillingToTravel']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('isAvailableForEmergencies')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="isAvailableForEmergencies"
          class="ppl-form-label">{{getAttributes('isAvailableForEmergencies').label}}
          @if(getAttributes('isAvailableForEmergencies').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control [nzSm]="16" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('isAvailableForEmergencies')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <nz-radio-group [ngClass]="{'error': validationErrors['isAvailableForEmergencies'] }"
              formControlName="isAvailableForEmergencies" class="ppl-radio-group" id="isAvailableForEmergencies"
              [attr.aria-invalid]="validationErrors['isAvailableForEmergencies'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['isAvailableForEmergencies'] ? 'isAvailableForEmergencies-error' : null">
              @for(opt of radioOptions; track $index){
              <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['isAvailableForEmergencies']) {
          <span class="pl-1 error-message" id="isAvailableForEmergencies-error"
            role="alert">{{validationErrors['isAvailableForEmergencies']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('dayEmergencyAvailablity')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="dayEmergencyAvailablity"
          class="ppl-form-label">{{getAttributes('dayEmergencyAvailablity').label}}
          @if(getAttributes('dayEmergencyAvailablity').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <div class="time-picker-new" [ngClass]="{'error': validationErrors['dayEmergencyAvailablity'] }">
          <ppl-timepicker class="p-calendar-time" formControlName="dayEmergencyAvailablityStart"
            id="dayEmergencyAvailablityStart" [placeholder]="'Select day emergency start time'"></ppl-timepicker>
          <ppl-timepicker class="p-calendar-time" formControlName="dayEmergencyAvailablityEnd"
            id="dayEmergencyAvailablityEnd" [placeholder]="'Select day emergency end time'"
            [attr.aria-invalid]="validationErrors['dayEmergencyAvailablity'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['dayEmergencyAvailablity'] ? 'dayEmergencyAvailablity-error' : null"></ppl-timepicker>

        </div>
        @if (validationErrors['dayEmergencyAvailablity']) {
        <span class="pl-1 error-message" id="dayEmergencyAvailablity-error"
          role="alert">{{validationErrors['dayEmergencyAvailablity']}}</span>
        }
        <!-- Custom validator error messages for day shift -->
        <span class="pl-1 error-message"
          *ngIf="preferncesForm.get('dayEmergencyAvailablityStart')?.errors?.['dayStartTimeRequired']">
          Start time is required if end time is set.
        </span>
        <span class="pl-1 error-message"
          *ngIf="preferncesForm.get('dayEmergencyAvailablityEnd')?.errors?.['dayEndTimeRequired']">
          End time is required if start time is set.
        </span>
        <span class="pl-1 error-message"
          *ngIf="preferncesForm.get('dayEmergencyAvailablityStart')?.errors?.['dayShiftTimeInvalid'] || preferncesForm.get('dayEmergencyAvailablityEnd')?.errors?.['dayShiftTimeInvalid']">
          Start time must be before end time.
        </span>
        <span class="pl-1 error-message"
          *ngIf="preferncesForm.get('dayEmergencyAvailablityStart')?.errors?.['dayShiftInvalid'] || preferncesForm.get('dayEmergencyAvailablityEnd')?.errors?.['dayShiftInvalid']">
          Day Emergency Start / End time must be between 6:00 AM and 10:00 PM.
        </span>
      </nz-form-item>
      }
      @if(isAttrAvailable('nightEmergencyAvailablity')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="nightEmergencyAvailablity"
          class="ppl-form-label">{{getAttributes('nightEmergencyAvailablity').label}}
          @if(getAttributes('nightEmergencyAvailablity').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <div class="time-picker-new" [ngClass]="{'error': validationErrors['nightEmergencyAvailablity'] }">
          <ppl-timepicker class="p-calendar-time" formControlName="nightEmergencyAvailablityStart"
            id="nightEmergencyAvailablityStart" [placeholder]="'Select night emergency start time'"
            ></ppl-timepicker>
          <ppl-timepicker formControlName="nightEmergencyAvailablityEnd" id="nightEmergencyAvailablityEnd"
            [placeholder]="'Select night emergency end time'"
            [attr.aria-invalid]="validationErrors['nightEmergencyAvailablity'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['nightEmergencyAvailablity'] ? 'nightEmergencyAvailablity-error' : null"></ppl-timepicker>

        </div>
        @if (validationErrors['nightEmergencyAvailablity']) {
        <span class="pl-1 error-message" id="nightEmergencyAvailablity-error"
          role="alert">{{validationErrors['nightEmergencyAvailablity']}}</span>
        }
        <!-- Custom validator error messages for night shift -->
        <span class="pl-1 error-message"
          *ngIf="preferncesForm.get('nightEmergencyAvailablityStart')?.errors?.['nightStartTimeRequired']">
          Start time is required if end time is set.
        </span>
        <span class="pl-1 error-message"
          *ngIf="preferncesForm.get('nightEmergencyAvailablityEnd')?.errors?.['nightEndTimeRequired']">
          End time is required if start time is set.
        </span>
        <span class="pl-1 error-message"
          *ngIf="preferncesForm.get('nightEmergencyAvailablityStart')?.errors?.['nightShiftTimeInvalid'] || preferncesForm.get('nightEmergencyAvailablityEnd')?.errors?.['nightShiftTimeInvalid']">
          Start time must be before end time.
        </span>
        <span class="pl-1 error-message"
          *ngIf="preferncesForm.get('nightEmergencyAvailablityStart')?.errors?.['nightShiftInvalid'] || preferncesForm.get('nightEmergencyAvailablityEnd')?.errors?.['nightShiftInvalid']">
          Night Emergency Start / End time must be between 10:00 PM and 6:00 AM.
        </span>
      </nz-form-item>
      }
    </form>
  </nz-card>
</div>
}
@else if(mode==="read"){
<div tabindex="0">
  @if(isAttrAvailable('contactType')){
  <div nz-row>
    <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('contactType').label}} :</div>
    <div nz-col nzSpan="16">
      <span>
        {{ getLookupValue(contactType, filledInfo['contactType'])}}
      </span>
      <span *ngIf="!filledInfo['contactType']" class="sr-only">Blank</span>
    </div>
  </div>
  }
  @if(preferncesForm.get('contactType')?.value === 'OTH'){
  @if(isAttrAvailable('contactFirstName')){
  <div nz-row>
    <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('contactFirstName').label}} :</div>
    <div nz-col nzSpan="16">
      <span>
        {{ filledInfo['contactFirstName']}}
      </span>
      <span *ngIf="!filledInfo['contactFirstName']" class="sr-only">Blank</span>
    </div>
  </div>
  }
  @if(isAttrAvailable('contactLastName')){
  <div nz-row>
    <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('contactLastName').label}} :</div>
    <div nz-col nzSpan="16">
      <span>
        {{ filledInfo['contactLastName']}}
      </span>
      <span *ngIf="!filledInfo['contactLastName']" class="sr-only">Blank</span>
    </div>
  </div>
  }
  @if(isAttrAvailable('contactEmail')){
  <div nz-row>
    <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('contactEmail').label}} :</div>
    <div nz-col nzSpan="16">
      <span>
        {{ filledInfo['contactEmail']}}
      </span>
      <span *ngIf="!filledInfo['contactEmail']" class="sr-only">Blank</span>
    </div>
  </div>
  }
  @if(isAttrAvailable('contactPhone')){
  <div nz-row>
    <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('contactPhone').label}} :</div>
    <div nz-col nzSpan="16">
      <span>
        {{ filledInfo['contactPhone']}}
      </span>
      <span *ngIf="!filledInfo['contactPhone']" class="sr-only">Blank</span>
    </div>
  </div>
  }
  }
  @if(isAttrAvailable('registerPref')){
  <div nz-row>
    <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('registerPref').label}} :</div>
    <div nz-col nzSpan="16">
      <span>
        {{ getLookupValue(participantRegisterMode,filledInfo['registerPref'])}}
      </span>
      <span *ngIf="!filledInfo['registerPref']" class="sr-only">Blank</span>
    </div>
  </div>
  }
  @if(isAttrAvailable('spokenLanguages')){
  <div nz-row>
    <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('spokenLanguages').label}} :</div>
    <div nz-col nzSpan="16">
      <span>
        {{ getLookupValue(languages,filledInfo['spokenLanguages'])}}
      </span>
      <span *ngIf="!filledInfo['spokenLanguages']" class="sr-only">Blank</span>
    </div>
  </div>
  }
  @if(isAttrAvailable('primaryLanguage')){
  <div nz-row>
    <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('primaryLanguage').label}} :</div>
    <div nz-col nzSpan="16">
      <span>
        {{ getLookupValue(languages,filledInfo['primaryLanguage'])}}
      </span>
      <span *ngIf="!filledInfo['primaryLanguage']" class="sr-only">Blank</span>
    </div>
  </div>
  }
  @if(isAttrAvailable('formLanguage')){
  <div nz-row>
    <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('formLanguage').label}} :</div>
    <div nz-col nzSpan="16">
      <span>
        {{ getLookupValue(languages,filledInfo['formLanguage'])}}
      </span>
      <span *ngIf="!filledInfo['formLanguage']" class="sr-only">Blank</span>
    </div>
  </div>
  }
  @if(isAttrAvailable('daysToContact')){
  <div nz-row>
    <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('daysToContact').label}} :</div>
     <div nz-col nzSpan="16">
      <span>
        {{ filledInfo['daysToContact'] }} {{ (filledInfo['startContactTime'] | date:'h:mm a')}} {{
      (filledInfo['endContactTime'] | date:'h:mm a') }}
      </span>
      <span *ngIf="!isAnyDaySelected()" class="sr-only">Blank</span>
    </div>
  </div>
  }
  @if(isAttrAvailable('otherDetails')){
  <div nz-row>
    <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('otherDetails').label}} :</div>
    <div nz-col nzSpan="16">
      <span>
        {{ filledInfo['otherDetails'] }}
      </span>
      <span *ngIf="!filledInfo['otherDetails']" class="sr-only">Blank</span>
    </div>
  </div>
  }
  @if(isAttrAvailable('specialAccomdation')){
  <div nz-row>
    <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('specialAccomdation').label}} :</div>
    <div nz-col nzSpan="16">
      <span>
        {{ getLookupValue(accommodations, filledInfo['specialAccomdation'])}}
      </span>
      <span *ngIf="!filledInfo['specialAccomdation']" class="sr-only">Blank</span>
    </div>
  </div>
  }
  @if(preferncesForm.get('specialAccomdation')?.value === 'OTH'){
  @if(isAttrAvailable('specialAccomdationOther')){
  <div nz-row>
    <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('specialAccomdationOther').label}} :</div>
    <div nz-col nzSpan="16">
      <span>
        {{ filledInfo['specialAccomdationOther'] }}
      </span>
      <span *ngIf="!filledInfo['specialAccomdationOther']" class="sr-only">Blank</span>
    </div>
  </div>
  }
  }
  @if(isAttrAvailable('emergencyContact')){
  <div nz-row>
    <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('emergencyContact').label}} :</div>
  </div>
  <div nz-row>
    <div nz-col nzSpan="8" class="">First Name :</div>
    <div nz-col nzSpan="16">
      <span>
        {{ filledInfo['emergencyContactFirstName']}}
      </span>
      <span *ngIf="!filledInfo['emergencyContactFirstName']" class="sr-only">Blank</span>
    </div>
  </div>
  <div nz-row>
    <div nz-col nzSpan="8" class="">Last Name :</div>
    <div nz-col nzSpan="16">
      <span>
        {{ filledInfo['emergencyContactLastName']}}
      </span>
      <span *ngIf="!filledInfo['emergencyContactLastName']" class="sr-only">Blank</span>
    </div>
  </div>
  <div nz-row>
    <div nz-col nzSpan="8" class="">Contact Number :</div>
    <div nz-col nzSpan="16">
      <span>
        {{ filledInfo['emergencyContactPhone']}}
      </span>
      <span *ngIf="!filledInfo['emergencyContactPhone']" class="sr-only">Blank</span>
    </div>
  </div>
  }
  @if(isAttrAvailable('availabilityDays')){
  <div nz-row>
    <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('availabilityDays').label}} :</div>
    <div nz-col nzSpan="16">
      <span>
        {{filledInfo['availabilityDays']}}
      </span>
      <span *ngIf="!filledInfo['availabilityDays']" class="sr-only">Blank</span>
    </div>
  </div>
  }
  @if(isAttrAvailable('availabilityTiming')){
  <div nz-row>
    <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('availabilityTiming').label}} :</div>
      <div nz-col nzSpan="16">
        <span>
          {{filledInfo['availabilityTimingStart'] | date:'h:mm a'}}
          {{filledInfo['availabilityTimingEnd'] |date:'h:mm a'}}
        </span>
        <span *ngIf="!filledInfo['availabilityTimingStart']" class="sr-only">Blank</span>
      </div>
  </div>
  }
  @if(isAttrAvailable('distanceWillingToTravel')){
  <div nz-row>
    <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('distanceWillingToTravel').label}} :</div>
    <div nz-col nzSpan="16">
      <span>
        {{ filledInfo['distanceWillingToTravel']}}
      </span>
      <span *ngIf="!filledInfo['distanceWillingToTravel']" class="sr-only">Blank</span>
    </div>
  </div>
  }
  @if(isAttrAvailable('isAvailableForEmergencies')){
  <div nz-row>
    <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('isAvailableForEmergencies').label}} :</div>
    <div nz-col nzSpan="16">
      <span>
        {{ filledInfo['isAvailableForEmergencies']}}
      </span>
      <span *ngIf="!filledInfo['isAvailableForEmergencies']" class="sr-only">Blank</span>
    </div>
  </div>
  }
  @if(isAttrAvailable('dayEmergencyAvailablity')){
  <div nz-row>
    <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('dayEmergencyAvailablity').label}} :</div>
    @if(filledInfo['dayEmergencyAvailablityStart'] || filledInfo['dayEmergencyAvailablityEnd']){
      <div nz-col nzSpan="16">
        <span>
          {{filledInfo['dayEmergencyAvailablityStart'] | date:'h:mm a'}} -
      {{filledInfo['dayEmergencyAvailablityEnd'] | date:'h:mm a'}}
        </span>
        <span *ngIf="!filledInfo['dayEmergencyAvailablityStart']" class="sr-only">Blank</span>
      </div>
    }
  </div>
  }
  @if(isAttrAvailable('nightEmergencyAvailablity')){
  <div nz-row>
    <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('nightEmergencyAvailablity').label}} :</div>
    @if(filledInfo['nightEmergencyAvailablityStart'] || filledInfo['nightEmergencyAvailablityEnd']){
      <div nz-col nzSpan="16">
        <span>
          {{filledInfo['nightEmergencyAvailablityStart'] | date:'h:mm a'}} -
          {{filledInfo['nightEmergencyAvailablityEnd'] | date:'h:mm a'}}
        </span>
        <span *ngIf="!filledInfo['nightEmergencyAvailablityStart']" class="sr-only">Blank</span>
      </div>
    }
  </div>
  }
</div>
}